import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['frame']

  load() {
    if (this.requested) {
      return
    }

    this.frameTarget.src = this.frameTarget.dataset.src
  }

  open(event) {
    if (this.loaded) {
      return
    }

    event.preventDefault()

    if (!this.opening) {
      this.opening = true
      this.frameTarget.addEventListener('turbo:frame-load', () => this.openMenu(), { once: true })
    }

    this.load()
  }

  openMenu() {
    this.frameTarget.querySelector('[data-tippy-target="origin"], [data-dropdown-target="button"]')?.click()
  }

  get requested() {
    return this.frameTarget.hasAttribute('src')
  }

  get loaded() {
    return this.frameTarget.hasAttribute('complete')
  }
}
